// a reducer takes in two things
// 1. the action (info about what happened)
// 2. copy of current state

import * as types from '../constants/actionTypes';

export default function currentUser(state = [], action) {
    const setCurrentUser = () => {
        console.log('Reducer:  Setting User');

        function findUser(user) {
            return user.userId === action.userId;
        }

        return {
            ...action.users.find(findUser)
        };

        // return state;

        // const i = action.index;
        // return [
        //     ...state.slice(0, i), // before the one we are updating
        //     {...state[i], likes: state[i].likes + 1},
        //     ...state.slice(i + 1), // after the one we are updating
        // ]
    };

    // contains all acceptable actions
    const acceptedActions = {
        [types.SET_CURRENT_USER]: setCurrentUser
    };

    // return state as it was if no accepted action
    if (typeof acceptedActions[action.type] === 'undefined') {
        return state;
    }

    // run state change code
    return acceptedActions[action.type]();
}



/** WEBPACK FOOTER **
 ** ./src/reducers/currentUser.js
 **/